'use client';

import clsx from 'clsx';
import { FC } from 'react';
import { BannerThemeHeroStoryblok } from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { H1, P } from 'atoms/Typography';
import { useMediaQuery } from 'modules/mui/hooks';
import styles from './styles.module.css';

export const ThemeHeroBanner: FC<{ blok: BannerThemeHeroStoryblok }> = ({
  blok,
}) => {
  const { isTablet } = useMediaQuery();
  const isBannerVisible =
    blok.background?.filename ||
    blok.mobileBackground?.filename ||
    blok.image?.filename ||
    blok.title ||
    blok.subtitle; // check if at least one field is filled, then the banner will be rendered

  const getBackgroundImage = () => {
    if (!isTablet && blok.mobileBackground?.filename) {
      return { backgroundImage: `url(${blok.mobileBackground.filename})` };
    }

    if (isTablet && blok.background?.filename) {
      return { backgroundImage: `url(${blok.background.filename})` };
    }
  };

  return !isBannerVisible ? null : (
    <div className={styles.root}>
      {isTablet && (
        <>
          {blok.leftImage?.filename && (
            <div className={clsx(styles.sideImage, styles.leftSideImage)}>
              <Image
                src={blok.leftImage.filename}
                alt={blok.leftImage?.alt}
                className={styles.decorativeImage}
              />
            </div>
          )}
          {blok.rightImage?.filename && (
            <div className={clsx(styles.sideImage, styles.rightSideImage)}>
              <Image
                src={blok.rightImage.filename}
                alt={blok.rightImage?.alt}
                className={styles.decorativeImage}
              />
            </div>
          )}
        </>
      )}
      <div className={styles.container}>
        <div className={styles.banner} style={getBackgroundImage()}>
          {isTablet && blok.image?.filename && (
            <Image
              src={blok.image.filename}
              alt={blok.image?.alt}
              className={styles.mainImage}
            />
          )}

          {(blok.title || blok.subtitle) && (
            <div className={styles.info}>
              {blok.title && <H1 className={styles.title}>{blok.title}</H1>}
              {blok.subtitle && (
                <P className={styles.subtitle}>{blok.subtitle}</P>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
